import React from 'react';

import classNames from 'classnames';

import './index.scss';

const MutateCardLegend = ({ comonent: Component = 'div', ...props }) => (
  <Component
    {...props}
    className={classNames(
      'mutate-card-legend',
      // eslint-disable-next-line react/destructuring-assignment
      props.className,
    )}
  >
    {/* eslint-disable-next-line react/destructuring-assignment */}
    {props.children}
  </Component>
);

export default MutateCardLegend;
